// Generated R layer lookup table
// Contains flattened taxonomy for Rights

export const R_LAYER_LOOKUP = {
  MVR: {
    numericCode: '001',
    name: 'Music_Video_Rights',
  },
  'MVR.POP': {
    numericCode: '001',
    name: 'Pop_Rights',
  },
  'MVR.RCK': {
    numericCode: '002',
    name: 'Rock_Rights',
  },
  'MVR.HIP': {
    numericCode: '003',
    name: 'Hip_Hop_Rights',
  },
  'MVR.LAT': {
    numericCode: '004',
    name: 'Latin_Rights',
  },
  'MVR.JZZ': {
    numericCode: '005',
    name: 'Jazz_Rights',
  },
  REG: {
    numericCode: '002',
    name: 'Regional_Rights',
  },
  'REG.GLB': {
    numericCode: '001',
    name: 'Global',
  },
  'REG.NAM': {
    numericCode: '002',
    name: 'North_America',
  },
  'REG.EUR': {
    numericCode: '003',
    name: 'Europe',
  },
  'REG.APC': {
    numericCode: '004',
    name: 'Asia_Pacific',
  },
  'REG.LAM': {
    numericCode: '005',
    name: 'Latin_America',
  },
  'REG.AFR': {
    numericCode: '006',
    name: 'Africa',
  },
  'REG.MDE': {
    numericCode: '007',
    name: 'Middle_East',
  },
  'REG.ANZ': {
    numericCode: '008',
    name: 'Australia_NZ',
  },
  USG: {
    numericCode: '003',
    name: 'Usage_Rights',
  },
  'USG.COM': {
    numericCode: '001',
    name: 'Commercial',
  },
  'USG.NCM': {
    numericCode: '002',
    name: 'Non_Commercial',
  },
  'USG.EDU': {
    numericCode: '003',
    name: 'Educational',
  },
  'USG.PER': {
    numericCode: '004',
    name: 'Personal',
  },
  'USG.BRD': {
    numericCode: '005',
    name: 'Brand_Specific',
  },
  'USG.EDT': {
    numericCode: '006',
    name: 'Editorial',
  },
  BRR: {
    numericCode: '004',
    name: 'Branded_Rights',
  },
  'BRR.LIC': {
    numericCode: '001',
    name: 'Licensing',
  },
  'BRR.SPN': {
    numericCode: '002',
    name: 'Sponsorship',
  },
  'BRR.COL': {
    numericCode: '003',
    name: 'Collaboration',
  },
};

export const R_SUBCATEGORIES = {
  MVR: ['MVR.POP', 'MVR.RCK', 'MVR.HIP', 'MVR.LAT', 'MVR.JZZ'],
  REG: [
    'REG.GLB',
    'REG.NAM',
    'REG.EUR',
    'REG.APC',
    'REG.LAM',
    'REG.AFR',
    'REG.MDE',
    'REG.ANZ',
  ],
  USG: ['USG.COM', 'USG.NCM', 'USG.EDU', 'USG.PER', 'USG.BRD', 'USG.EDT'],
  BRR: ['BRR.LIC', 'BRR.SPN', 'BRR.COL'],
};
